import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {Dialog, Button, Typography, CircularProgress} from "@material-ui/core";
import {
    INewParcelaSection,
    INotificacion,
    IParcela,
    IPointCoords,
    ISections,
    ISistemasProduccion,
    woody_crops
} from "../../../types";
import {NavigateBefore} from "@material-ui/icons";
import axios from "axios";
import config from "../../../config.json";
import {userService} from "../../../services/UserService";
import {LatLngTuple} from "leaflet";

const geolib = require('geolib');
const texts = require('../../../texts/crearparcela.json');

interface IProps {
    seccion: INewParcelaSection
    nombre: string
    propietario: string
    husoUTM: number
    bandaUTM: string
    usuarios: string[]
    cultivo: string
    id_estacion: number
    ubicacion_estacion: string
    coordenadas_estacion: IPointCoords
    sistema: null|ISistemasProduccion
    marco: string
    diametro: number
    textura: string
    polygon: LatLngTuple[]
    sectores: Record<string, LatLngTuple[]>
    fecha: string
    usuario: string
    level: number
    parcelas: IParcela[]
    dias: string
    idioma: string
    setParcelas(parcelas: IParcela[]): void
    setCrearParcelaSection(seccion: INewParcelaSection): void
    setPropietario(propietario: string): void
    setNombre(nombre: string): void
    setHusoUTM(huso: number): void
    setCultivo(cultivo: string): void
    notify(notification: INotificacion): void
    setIdEstacion(id_estacion: number): void
    setUbicacionEstacion(ubicacion_estacion: string): void
    setCoordenadasEstacion(coordenadas_estacion: IPointCoords): void
    setSistema(sistema: null|ISistemasProduccion): void
    setMarco(marco: string): void
    setDiametro(diametro: number): void
    selectSection(section: ISections): void
    setTextura(textura: string): void
    setPolygon(polygon: LatLngTuple[]): void
    setSectores(sectores: Record<string, LatLngTuple[]>): void
    setFecha(fecha: string): void
    setParcela(parcela: string): void,
    setPrincipalUsuario(usuario: string): void
    setLimiteHa(limiteHa: number): void
}

interface IState {
    text: Record<string, string>
    creando_parcela: boolean
}


class InfoFinal extends React.Component<IProps, IState> {
    state: IState = {
        text: texts[this.props.idioma],
        creando_parcela: false
    }

    componentDidMount() {
        this.setState({creando_parcela: false})
    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }
        return true
    }

    resetCrearParcela = () => {
        this.setState({creando_parcela: false})
        this.props.setNombre('')
        this.props.setPropietario('')
        this.props.setCultivo('')
        this.props.setPolygon([])
        this.props.setSectores({})
        this.props.setIdEstacion(0)
        this.props.setUbicacionEstacion('')
        this.props.setCoordenadasEstacion({} as IPointCoords)
        this.props.setSistema(null)
        this.props.setMarco('0x0')
        this.props.setDiametro(0)
        this.props.setTextura('')
        this.props.setFecha('')
        this.props.setCrearParcelaSection('Caracterización')
    }

    handleCreate = () => {
        this.setState({creando_parcela: true})
        axios.get(
            config.url+'/init',
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res: { data: IParcela[] }) => {
                this.props.setParcelas(res.data)


                if (this.props.level < 5) {
                    let parcelas = []
                    for (let parcela of this.props.parcelas) {
                        if (parcela.propietario.split(',').includes(this.props.usuario)) parcelas.push(parcela.id)
                    }
                    const parcelas_str = parcelas.join(',')
                    axios.get(
                        config.url+`/superficie/disponible?parcelas=${parcelas_str}`,
                        {auth: {
                                username: `${userService.getUser()}`,
                                password: `${userService.getPass()}`
                            }})
                        .then((res) => {

                            if (res.data.superficie <= 0) {
                                this.props.notify({message: this.state.text["0"], variant: 'warning'})
                                setTimeout(() => {this.props.selectSection("principal")}, 2000)
                            } else {
                                this.props.setLimiteHa(res.data.superficie)

                                if(res.data.superficie < Math.round(geolib.getAreaOfPolygon(this.props.polygon)/100)/100) {
                                    this.props.notify({message: this.state.text["50"], variant: 'warning'})
                                    this.props.setCrearParcelaSection('Ubicación')
                                } else {

                                    let Kr = 1
                                    if (woody_crops.includes(this.props.cultivo)) {
                                        Kr = (Math.PI*this.props.diametro**2)/(2*parseFloat(this.props.marco.split('x')[0])*parseFloat(this.props.marco.split('x')[1]))
                                        if (Kr > 1) Kr = 1
                                    }
                                    axios.post(
                                        config.url+'/crear/parcela',
                                        {
                                            nombre: this.props.nombre,
                                            propietario: this.props.propietario,
                                            cultivo: this.props.cultivo,
                                            id_estacion: this.props.id_estacion,
                                            ubicacion_estacion: this.props.ubicacion_estacion,
                                            coordenadas_estacion: this.props.coordenadas_estacion,
                                            huso: this.props.husoUTM,
                                            banda: this.props.bandaUTM,
                                            shape: this.props.polygon,
                                            sectores: this.props.sectores,
                                            Kr: Kr,
                                            textura: this.props.textura,
                                            superficie: geolib.getAreaOfPolygon(this.props.polygon),
                                            sistema_produccion: this.props.sistema,
                                            marco_plantacion: this.props.marco,
                                            diametro: this.props.diametro,
                                            fecha_plantacion: this.props.fecha,
                                            dias: this.props.dias
                                        },
                                        {auth: {
                                                username: `${userService.getUser()}`,
                                                password: `${userService.getPass()}`
                                            }
                                        })
                                        .then(() => {
                                            axios.get(
                                                config.url+'/init',
                                                {auth: {
                                                        username: `${userService.getUser()}`,
                                                        password: `${userService.getPass()}`
                                                    }})
                                                .then((res: { data: IParcela[] }) => {
                                                    this.props.setParcelas(res.data)
                                                    this.props.selectSection('principal')
                                                    for (let parcela of res.data) {
                                                        if (parcela.propietario.split(',').includes(this.props.propietario) && parcela.nombre === this.props.nombre) {
                                                            this.props.setPrincipalUsuario(this.props.propietario)
                                                            this.props.setParcela(parcela.id)
                                                        }
                                                    }

                                                    this.resetCrearParcela()
                                                    this.props.notify({message: this.state.text["51"], variant: 'success'})
                                                })
                                                .catch(() => {
                                                    this.props.notify({message: this.state.text["1"], variant: 'error'})
                                                    this.setState({creando_parcela: false})
                                                })
                                        })
                                        .catch(() => {
                                            this.props.notify({message: this.state.text["1"], variant: 'error'})
                                            this.setState({creando_parcela: false})
                                        })

                                }
                            }
                        })
                        .catch(() => {
                            this.setState({creando_parcela: false})
                            this.props.notify({message: this.state.text["1"], variant: 'error'})
                            this.props.selectSection("principal")
                        })
                } else {

                    let Kr = 1
                    if (woody_crops.includes(this.props.cultivo)) {
                        Kr = (Math.PI*this.props.diametro**2)/(2*parseFloat(this.props.marco.split('x')[0])*parseFloat(this.props.marco.split('x')[1]))
                        if (Kr > 1) Kr = 1
                    }

                    axios.post(
                        config.url+'/crear/parcela',
                        {
                            nombre: this.props.nombre,
                            propietario: this.props.propietario,
                            cultivo: this.props.cultivo,
                            id_estacion: this.props.id_estacion,
                            ubicacion_estacion: this.props.ubicacion_estacion,
                            coordenadas_estacion: this.props.coordenadas_estacion,
                            huso: this.props.husoUTM,
                            banda: this.props.bandaUTM,
                            shape: this.props.polygon,
                            sectores: this.props.sectores,
                            Kr: Kr,
                            textura: this.props.textura,
                            superficie: geolib.getAreaOfPolygon(this.props.polygon),
                            sistema_produccion: this.props.sistema,
                            marco_plantacion: this.props.marco,
                            diametro: this.props.diametro,
                            fecha_plantacion: this.props.fecha,
                            dias: this.props.dias
                        },
                        {auth: {
                                username: `${userService.getUser()}`,
                                password: `${userService.getPass()}`
                            }
                        })
                        .then(() => {
                            axios.get(
                                config.url+'/init',
                                {auth: {
                                        username: `${userService.getUser()}`,
                                        password: `${userService.getPass()}`
                                    }})
                                .then((res: { data: IParcela[] }) => {
                                    this.props.setParcelas(res.data)
                                    this.props.selectSection('principal')
                                    for (let parcela of res.data) {
                                        if (parcela.propietario.split(',').includes(this.props.propietario) && parcela.nombre === this.props.nombre) {
                                            this.props.setPrincipalUsuario(this.props.propietario)
                                            this.props.setParcela(parcela.id)
                                        }
                                    }

                                    this.resetCrearParcela()
                                    this.props.notify({message: this.state.text["51"], variant: 'success'})
                                })
                                .catch(() => {
                                    this.props.notify({message: this.state.text["1"], variant: 'error'})
                                    this.setState({creando_parcela: false})
                                })
                        })
                        .catch(() => {
                            this.setState({creando_parcela: false})
                        })
                }

            })
    }

    render () {
        return (
            <Dialog
                open={this.props.seccion == "InfoFinal"}
                // onClose={() => this.props.close()}
                PaperProps={{
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: "center",
                        overflow: "hidden",
                        width: "80%",
                        borderRadius: 40
                    }
                }}
                maxWidth={"lg"}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "80%",
                        overflowY: "auto"
                    }}
                >
                    <Typography
                        style={{
                            fontSize: 38,
                            fontWeight: "bold",
                            color: "#4C494B",
                            fontFamily: "Poppins",
                            marginTop: 30,
                            marginBottom: 40
                        }}
                    >
                        {this.state.text["52"]}
                    </Typography>


                    <Typography
                        style={{
                            fontSize: 18,
                            color: "#4C494B",
                            fontFamily: "Poppins",
                            marginBottom: 40
                        }}
                    >
                        {this.state.text["53"]}
                        <br/>
                        <br/>
                        {this.state.text["59"]}
                        <br/>
                        <br/>
                        {this.state.text["60"]}

                    </Typography>


                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: 30
                        }}
                    >
                        <Button
                            style={{
                                height: "fit-content",
                                borderRadius: 10
                            }}
                            onClick={() => this.props.setCrearParcelaSection("Sectores")}
                        >
                            <NavigateBefore
                                style={{
                                    height: 30,
                                    width: 30
                                }}
                            />
                            <Typography
                                style={{
                                    textTransform: "none",
                                    fontSize: 20,
                                    fontWeight: "bold",
                                    marginLeft: 10,
                                    textDecoration: 'underline',
                                    fontFamily: "Poppins"
                                }}
                            >
                                {this.state.text["35"]}
                            </Typography>
                        </Button>

                        <Button
                            style={{
                                height: "fit-content",
                                borderRadius: 10,
                                width: 200
                            }}
                            variant={"contained"}
                            color={"primary"}
                            disabled={this.state.creando_parcela}
                            onClick={() => this.handleCreate()}
                        >
                            {this.state.creando_parcela?
                                <CircularProgress
                                    style={{
                                        height: 36,
                                        width: 36,
                                        color: "#b42333"
                                    }}
                                />
                                :
                                <Typography
                                    style={{
                                        textTransform: "none",
                                        fontSize: 20,
                                        fontWeight: "bold",
                                        marginLeft: 10,
                                        fontFamily: "Poppins"
                                    }}
                                >
                                    {this.state.text["61"]}
                                </Typography>
                            }
                        </Button>

                    </div>

                </div>

            </Dialog>
        )
    }

}

const mapStateToProps = (state: IStore) => ({
    seccion: state.crearParcela.seccion,
    nombre: state.crearParcela.nombre,
    propietario: state.crearParcela.propietario,
    husoUTM: state.crearParcela.huso,
    bandaUTM: state.crearParcela.banda,
    usuarios: state.principal.usuarios,
    cultivo: state.crearParcela.cultivo,
    id_estacion: state.crearParcela.id_estacion,
    ubicacion_estacion: state.crearParcela.ubicacion_estacion,
    coordenadas_estacion: state.crearParcela.coordenadas_estacion,
    sistema: state.crearParcela.sistema,
    marco: state.crearParcela.marco,
    diametro: state.crearParcela.diametro,
    textura: state.crearParcela.textura,
    polygon: state.crearParcela.polygon,
    sectores: state.crearParcela.sectores,
    fecha: state.crearParcela.fecha,
    usuario: state.principal.usuario,
    level: state.navegacion.level,
    parcelas: state.principal.parcelas,
    dias: state.crearParcela.dias,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setParcelas: (parcelas: IParcela[]) => dispatch({type: "set-principal-parcelas", parcelas}),
    setCrearParcelaSection: (seccion: INewParcelaSection) => dispatch({type: "select-crear-parcela-seccion", seccion}),
    setNombre: (nombre: string) => dispatch({type: "set-crear-parcela-nombre", nombre}),
    setPropietario: (propietario: string) => dispatch({type: "set-crear-parcela-propietario", propietario}),
    setHusoUTM: (huso: number) => dispatch({type:"set-crear-parcela-huso", huso}),
    setCultivo: (cultivo: string) => dispatch({type:"set-crear-parcela-cultivo", cultivo}),
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    setIdEstacion: (id_estacion: number) => dispatch({type: "set-crear-parcela-id_estacion", id_estacion}),
    setUbicacionEstacion: (ubicacion_estacion: string) => dispatch({type: "set-crear-parcela-ubicacion_estacion", ubicacion_estacion}),
    setCoordenadasEstacion: (coordenadas_estacion: IPointCoords) => dispatch({type: "set-crear-parcela-coordenadas_estacion", coordenadas_estacion}),
    setSistema: (sistema: null|ISistemasProduccion) => dispatch({type: "set-crear-parcela-sistema", sistema}),
    setMarco: (marco: string) => dispatch({type: "set-crear-parcela-marco", marco}),
    setDiametro: (diametro: number) => dispatch({type: "set-crear-parcela-diametro", diametro}),
    selectSection: (section: ISections) => dispatch({type: "select-section", section}),
    setTextura: (textura: string) => dispatch({type: "set-crear-parcela-textura", textura}),
    setPolygon: (polygon: LatLngTuple[]) => dispatch({type: "set-crear-parcela-polygon", polygon}),
    setSectores: (sectores: Record<string, LatLngTuple[]>) => dispatch({type: "set-crear-parcela-sectores", sectores}),
    setFecha: (fecha: string) => dispatch({type: "set-crear-parcela-fecha", fecha}),
    setParcela: (parcela: string) => dispatch({type: "set-parcela", parcela}),
    setPrincipalUsuario: (usuario: string) => dispatch({type: "set-principal-usuario", usuario}),
    setLimiteHa: (limiteHa: number) => dispatch({type: "set-crear-parcela-limiteHa", limiteHa})
});

export default connect(mapStateToProps, mapDispatchToProps)(InfoFinal);
